import React, { useState } from 'react';
import { motion, AnimatePresence } from 'motion/react';
import { X, Mail } from 'lucide-react';
import { Button } from '@/components/ui/Button';
import { NewsletterForm } from '@/components/forms/NewsletterForm';

export function NewsletterModal() {
  const [isOpen, setIsOpen] = useState(false);

  // Lock body scroll when open
  React.useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);

  return (
    <>
      <Button 
        onClick={() => setIsOpen(true)} 
        variant="outline"
        className="mt-8 border-rule-3 text-rule-3 hover:bg-rule-3 hover:text-ink flex items-center justify-center gap-2 max-w-xs w-full sm:w-auto"
      >
        <Mail className="w-4 h-4" />
        Join Newsletter
      </Button>

      <AnimatePresence>
        {isOpen && (
          <>
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 0.2 }}
              onClick={() => setIsOpen(false)}
              className="fixed inset-0 bg-ink/80 backdrop-blur-sm z-[100]"
            />
            
            <div className="fixed inset-0 pointer-events-none z-[101] flex items-center justify-center p-4">
              <motion.div
                initial={{ opacity: 0, y: 20, scale: 0.95 }}
                animate={{ opacity: 1, y: 0, scale: 1 }}
                exit={{ opacity: 0, y: 20, scale: 0.95 }}
                transition={{ type: 'spring', damping: 25, stiffness: 300 }}
                className="pointer-events-auto relative w-full max-w-md bg-ink border border-ground-deep p-8 sm:p-10 shadow-2xl flex flex-col items-center text-center"
              >
                <button
                  onClick={() => setIsOpen(false)}
                  className="absolute top-4 right-4 text-ground hover:text-white transition-colors p-2"
                  aria-label="Close modal"
                >
                  <X className="w-5 h-5" />
                </button>
                
                <div className="w-16 h-16 rounded-full bg-rule-3/20 text-rule-3 border border-rule-3/30 flex items-center justify-center mb-6">
                  <Mail className="w-8 h-8" />
                </div>
                
                {/* Form Wrapper overriding the default alignment to be centered */}
                <div className="w-full flex flex-col items-center">
                  <NewsletterForm className="w-full flex flex-col items-center" />
                </div>
              </motion.div>
            </div>
          </>
        )}
      </AnimatePresence>
    </>
  );
}
